// React Component
import React from 'react';
import { NavLink } from "react-router-dom";

// App Component
import Routes from "../Routes"
import { Images } from "../../constants"
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { useBranding } from '../../contexts/BrandingContext';
import type { CSSProperties } from 'react';
interface ChildProps {
    className: string
}

const DashNavigation = (props: ChildProps) => {
    const { className } = props
    const { t } = useTranslation()
    const { theme } = useTheme();
    const { getLogo } = useBranding();
    const isLightMode = theme === 'light';
    const displayLogo = getLogo(theme) || Images.logov1;
    const inactiveNavClass = "nav-link dash-nav-link";
    const getNavStyle = (isActive: boolean): CSSProperties => ({
        color: isLightMode ? '#111827' : 'var(--text-primary)',
        opacity: isLightMode ? 1 : (isActive ? 1 : 0.75),
    });
    return (
        <nav
            className={`${className} second_bg dashboard-sidebar`}
            style={{
                background: 'var(--bg-secondary)',
                color: 'var(--text-primary)',
                borderRight: isLightMode ? '1px solid var(--border-subtle)' : '1px solid transparent'
            }}
        >
            <div className="position-sticky vh-100 pt-3">
                <NavLink className="navbar-vertical_navlink m-none" to={Routes.HOMEVIEW} >
                    <img src={displayLogo} alt="" style={{ maxWidth: 100, maxHeight: 50, objectFit: 'contain' }} />
                </NavLink>
                <ul className="nav flex-column mt-3 position-relative">
                    <li className="nav-item">
                        <NavLink
                            to={Routes.DASHBOARDS}
                            className={({ isActive }) => isActive ? "nav-link fw-bold active dash-nav-link" : inactiveNavClass}
                            style={({ isActive }) => getNavStyle(isActive)}
                        >
                            <i className="fa-solid fa-tachometer-alt me-1"></i>  {t('dashboard.dashboard')}
                        </NavLink>
                    </li>
                    <li className='mx-3 border-bottom dash-nav-divider my-2'></li>
                    <li className="nav-item" data-tutorial="admin-users">
                        <NavLink
                            to={Routes.USERS_LIST}
                            className={({ isActive }) => isActive ? "nav-link fw-bold active dash-nav-link" : inactiveNavClass}
                            style={({ isActive }) => getNavStyle(isActive)}
                        >
                            <i className="fa fa-user-friends me-1"></i> {t('dashboard.users')}
                        </NavLink>
                    </li>
                    {/* <li className='mx-3 border-bottom border-secondary opacity-50 my-2'></li>
                    <li className="nav-item">
                        <NavLink to={Routes.COLLABORATORS_LIST} className={({ isActive }) => isActive ? "nav-link fw-bold active text-light" : "nav-link  text-light opacity-50"}>
                            <i className="fa fa-people-group me-1"></i> {t('dashboard.collaborators')}
                        </NavLink>
                    </li>
                    <li className='mx-3 border-bottom border-secondary opacity-50 my-2'></li>
                    <li className="nav-item">
                        <NavLink to={Routes.OWNER_LIST} className={({ isActive }) => isActive ? "nav-link fw-bold active text-light" : "nav-link  text-light opacity-50"}>
                            <i className="fa fa-user-tie me-1"></i> {t('dashboard.processOwners')}
                        </NavLink>
                    </li> */}

                    <li className='mx-3 border-bottom dash-nav-divider my-2'></li>
                    <li className="nav-item" data-tutorial="admin-administrators">
                        <NavLink
                            to={Routes.ADMIN_LIST}
                            className={({ isActive }) => isActive ? "nav-link fw-bold active dash-nav-link" : inactiveNavClass}
                            style={({ isActive }) => getNavStyle(isActive)}
                        >
                            <i className="fa fa-user-cog me-1"></i> {t('dashboard.admin')}
                        </NavLink>
                    </li>
                    <li className='mx-3 border-bottom dash-nav-divider my-2'></li>
                    <li className="nav-item" data-tutorial="admin-andon">
                        <NavLink
                            to={Routes.ANDON_HUB}
                            className={({ isActive }) => isActive ? "nav-link fw-bold active dash-nav-link" : inactiveNavClass}
                            style={({ isActive }) => getNavStyle(isActive)}
                        >
                            <i className="fa-solid fa-flag me-1"></i> {t('dashboard.andon', 'Andon')}
                        </NavLink>
                    </li>
                    <li className='mx-3 border-bottom dash-nav-divider my-2'></li>
                    <li className="nav-item" data-tutorial="admin-microsoft">
                        <NavLink
                            to={Routes.MICROSOFT_INTEGRATIONS}
                            className={({ isActive }) => isActive ? "nav-link fw-bold active dash-nav-link" : inactiveNavClass}
                            style={({ isActive }) => getNavStyle(isActive)}
                        >
                            <i className="fa-brands fa-microsoft me-1"></i> {t('dashboard.microsoft', 'Microsoft')}
                        </NavLink>
                    </li>
                    <li className='mx-3 border-bottom dash-nav-divider my-2'></li>
                    <li className="nav-item" data-tutorial="admin-library">
                        <NavLink
                            to={Routes.PROCESS_LIST}
                            className={({ isActive }) => isActive ? "nav-link fw-bold active dash-nav-link" : inactiveNavClass}
                            style={({ isActive }) => getNavStyle(isActive)}
                        >
                            <i className="bi bi-collection me-1"></i> {t('views.processView.library')}
                        </NavLink>
                    </li>
                    <li className='mx-3 border-bottom dash-nav-divider my-2'></li>
                </ul>
            </div>
        </nav>
    )
}

export default DashNavigation; 